(function($) {
  $(function() {
    $('#notifications-list, .notifications-list').find('li').each(function() {
      var $toggle = $(this).find('.toggle-icon, .notification-title')

      $toggle.on('click', function() {
      	$(this).parent().toggleClass('inactive')
      })
    });
  })
})(jQuery);
